export default {
  af: "Afganistán",
  al: "Albania",
  dz: "Argel",
  as: "Samoa Americana",
  ad: "Andorra",
  ao: "Angola",
  ai: "Anguila",
  ag: "Antigua y Barbuda",
  ar: "Argentina",
  am: "Armenia",
  aw: "Aruba",
  au: "Australia",
  at: "Austria",
  az: "Azerbaiyán",
  bs: "Bahamas",
  bh: "Bahréin",
  bd: "Bangladesh",
  bb: "Barbados",
  by: "Belarús",
  be: "Bélgica",
  bz: "Belice",
  bj: "Benin",
  bm: "Bermudas",
  bt: "Bhután",
  bo: "Bolivia",
  ba: "Bosnia y Herzegovina",
  bw: "Botsuana",
  br: "Brasil",
  io: "Territorio Británico del Océano Índico",
  vg: "Islas Vírgenes Británicas",
  bn: "Brunéi",
  bg: "Bulgaria",
  bf: "Burkina Faso",
  bi: "Burundi",
  kh: "Camboya",
  cm: "Camerún",
  ca: "Canadá",
  cv: "Cabo Verde",
  bq: "Caribe Neerlandés",
  ky: "Islas Caimán",
  cf: "República Centro-Africana",
  td: "Chad",
  cl: "Chile",
  cn: "China",
  cx: "Islas Christmas",
  cc: "Islas Cocos",
  co: "Colombia",
  km: "Comoros",
  cd: "República Democrática del Congo",
  cg: "República del Congo",
  ck: "Islas Cook",
  cr: "Costa Rica",
  ci: "Costa de Marfil",
  hr: "Croacia",
  cu: "Cuba",
  cw: "Curazao",
  cy: "Chipre",
  cz: "República Checa",
  dk: "Dinamarca",
  dj: "Yibuti",
  dm: "Domínica",
  do: "República Dominicana",
  ec: "Ecuador",
  eg: "Egipto",
  sv: "El Salvador",
  gq: "Guinea Ecuatorial",
  er: "Eritrea",
  ee: "Estonia",
  et: "Etiopía",
  fk: "Islas Malvinas",
  fo: "Islas Faroe",
  fj: "Fiji",
  fi: "Finlandia",
  fr: "Francia",
  gf: "Guayana Francesa",
  pf: "Polinesia Francesa",
  ga: "Gabón",
  gm: "Gambia",
  ge: "Georgia",
  de: "Alemania",
  gh: "Ghana",
  gi: "Gibraltar",
  gr: "Grecia",
  gl: "Groenlandia",
  gd: "Granada",
  gp: "Guadalupe",
  gu: "Guam",
  gt: "Guatemala",
  gg: "Guernsey",
  gn: "Guinea",
  gw: "Guinea-Bissau",
  gy: "Guayana",
  ht: "Haití",
  hn: "Honduras",
  hk: "Hong Kong",
  hu: "Hungría",
  is: "Islandia",
  in: "India",
  id: "Indonesia",
  ir: "Irán",
  iq: "Irak",
  ie: "Irlanda",
  im: "Isla de Man",
  il: "Israel",
  it: "Italia",
  jm: "Jamaica",
  jp: "Japón",
  je: "Jersey",
  jo: "Jordania",
  kz: "Kazajstán",
  ke: "Kenia",
  ki: "Kiribati",
  xk: "Kosovo",
  kw: "Kuwait",
  kg: "Kirguistán",
  la: "Laos",
  lv: "Letonia",
  lb: "Líbano",
  ls: "Lesotho",
  lr: "Liberia",
  ly: "Libia",
  li: "Liechtenstein",
  lt: "Lituania",
  lu: "Luxemburgo",
  mo: "Macao",
  mk: "Macedonia",
  mg: "Madagascar",
  mw: "Malawi",
  my: "Malasia",
  mv: "Maldivas",
  ml: "Mali",
  mt: "Malta",
  mh: "Islas Marshall",
  mq: "Martinica",
  mr: "Mauritania",
  mu: "Mauricio",
  yt: "Mayotte",
  mx: "México",
  fm: "Micronesia",
  md: "Moldova",
  mc: "Mónaco",
  mn: "Mongolia",
  me: "Montenegro",
  ms: "Montserrat",
  ma: "Marruecos",
  mz: "Mozambique",
  mm: "Myanmar",
  na: "Namibia",
  nr: "Nauru",
  np: "Nepal",
  nl: "Países Bajos",
  nc: "Nueva Caledonia",
  nz: "Nueva Zelanda",
  ni: "Nicaragua",
  ne: "Níger",
  ng: "Nigeria",
  nu: "Niue",
  nf: "Islas Norkfolk",
  kp: "Corea del Norte",
  mp: "Islas Marianas del Norte",
  no: "Noruega",
  om: "Omán",
  pk: "Pakistán",
  pw: "Islas Palaos",
  ps: "Palestina",
  pa: "Panamá",
  pg: "Papúa Nueva Guinea",
  py: "Paraguay",
  pe: "Perú",
  ph: "Filipinas",
  pl: "Polonia",
  pt: "Portugal",
  pr: "Puerto Rico",
  qa: "Qatar",
  re: "Reunión",
  ro: "Rumanía",
  ru: "Rusia",
  rw: "Ruanda",
  bl: "San Bartolomé",
  sh: "Santa Elena",
  kn: "San Cristóbal y Nieves",
  lc: "Santa Lucía",
  mf: "Isla de San Martín",
  pm: "San Pedro y Miquelón",
  vc: "San Vicente y las Granadinas",
  ws: "Samoa",
  sm: "San Marino",
  st: "Santo Tomé y Príncipe",
  sa: "Arabia Saudita",
  sn: "Senegal",
  rs: "Serbia y Montenegro",
  sc: "Seychelles",
  sl: "Sierra Leona",
  sg: "Singapur",
  sx: "San Martín",
  sk: "Eslovaquia",
  si: "Eslovenia",
  sb: "Islas Solomón",
  so: "Somalia",
  za: "Sudáfrica",
  kr: "Corea del Sur",
  ss: "Sudán del Sur",
  es: "España",
  lk: "Sri Lanka",
  sd: "Sudán",
  sr: "Surinam",
  sj: "Islas Svalbard y Jan Mayen",
  sz: "Suazilandia",
  se: "Suecia",
  ch: "Suiza",
  sy: "Siria",
  tw: "Taiwán",
  tj: "Tayikistán",
  tz: "Tanzania",
  th: "Tailandia",
  tl: "Timor-Leste",
  tg: "Togo",
  tk: "Tokelau",
  to: "Tonga",
  tt: "Trinidad y Tobago",
  tn: "Túnez",
  tr: "Turquía",
  tm: "Turkmenistán",
  tc: "Islas Turcas y Caicos",
  tv: "Tuvalu",
  vi: "Islas Vírgenes de los Estados Unidos de América",
  ug: "Uganda",
  ua: "Ucrania",
  ae: "Emiratos Árabes Unidos",
  gb: "Reino Unido",
  us: "Estados Unidos de América",
  uy: "Uruguay",
  uz: "Uzbekistán",
  vu: "Vanuatu",
  va: "Ciudad del Vaticano",
  ve: "Venezuela",
  vn: "Vietnam",
  wf: "Wallis y Futuna",
  eh: "Sahara Occidental",
  ye: "Yemen",
  zm: "Zambia",
  zw: "Zimbabue",
  ax: "Islas Áland"
};
